module.exports = __webpack_public_path__ + "static/img/erweima.c8f3ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/erweima.png
// module id = E04A
// module chunks = 9